export interface GuestlistAccessFilterType {
  selectedAccessTypes: server.dto.GuestlistAccessType[]
  initialAccessTypes: server.dto.GuestlistAccessType[]
}

export const getSortedAccessTypes = (filter: GuestlistAccessFilterType) => {
  return [...filter.selectedAccessTypes].sort((a, b) => {
    const indexA = filter.initialAccessTypes.findIndex(value => value === a);
    const indexB = filter.initialAccessTypes.findIndex(value => value === b);
    return indexA - indexB;
  });
};

export const initialAccessFilter: GuestlistAccessFilterType = {
  selectedAccessTypes: [],
  initialAccessTypes: []
};